import React, { FC } from 'react';
import cn from 'clsx';
import { css } from 'linaria';

import AppLink from '../AppLink';
import AuthenticatedAppLink from '../AuthenticatedAppLink';

export const SQUARE_BUTTON_TYPE = 'SQUARE';
export const ROUND_BUTTON_TYPE = 'ROUND';
export const OUTLINE_BUTTON_TYPE = 'OUTLINE';
export const UNDERLINE_BUTTON_TYPE = 'UNDERLINE';
export const TEXT_BUTTON_TYPE = 'TEXT';

export const BLACK_BUTTON_COLOR = 'BLACK';
export const BLUE_BUTTON_COLOR = 'BLUE';
export const WHITE_BUTTON_COLOR = 'WHITE';
export const OUTLINE_BUTTON_COLOR = 'OUTLINE';

export const LARGE_SIZE = 'LARGE';
export const SMALL_SIZE = 'SMALL';

const BLACK_BUTTON_STYLES = 'text-white bg-lapel border-lapel hover:bg-black';
const BLUE_BUTTON_STYLES = 'text-white bg-gatsby border-gatsby hover:bg-dark-blue';
const WHITE_BUTTON_STYLES = 'text-lapel bg-white border-white hover:bg-dove';

const LARGE_TEXT_STYLES = css`
  font-size: 0.75rem;
  line-height: 1.25rem;
`;
const SMALL_TEXT_STYLES = css`
  font-size: 0.625rem;
  line-height: 0.75rem;
`;

const UNDERLINE_BLACK_BUTTON_STYLES = 'text-lapel border-lapel hover:text-black hover:border-black';
const UNDERLINE_BLUE_BUTTON_STYLES =
  'text-gatsby border-gatsby hover:text-dark-blue hover:border-dark-blue';
const UNDERLINE_WHITE_BUTTON_STYLES = 'text-white border-white hover:text-dove hover:border-dove';

const TEXT_BLACK_BUTTON_STYLES = 'text-gatsby hover:text-dark-blue';
const TEXT_BLUE_BUTTON_STYLES = 'text-lapel hover:text-black';
const TEXT_WHITE_BUTTON_STYLES = 'text-white hover:text-dove';

const BUTTON_TYPE_STYLES = {
  SQUARE: 'border uppercase',
  ROUND: 'rounded-full uppercase',
  TEXT: '',
  OUTLINE: 'border',
  UNDERLINE: 'uppercase border-b pb-0.25',
};

const BUTTON_COLOR_STYLES = {
  SQUARE: {
    BLACK: BLACK_BUTTON_STYLES,
    BLUE: BLUE_BUTTON_STYLES,
    WHITE: WHITE_BUTTON_STYLES,
  },
  OUTLINE: {
    BLACK: BLACK_BUTTON_STYLES,
    BLUE: BLUE_BUTTON_STYLES,
    WHITE: WHITE_BUTTON_STYLES,
  },
  ROUND: {
    BLACK: BLACK_BUTTON_STYLES,
    BLUE: BLUE_BUTTON_STYLES,
    WHITE: WHITE_BUTTON_STYLES,
  },
  TEXT: {
    BLACK: TEXT_BLACK_BUTTON_STYLES,
    BLUE: TEXT_BLUE_BUTTON_STYLES,
    WHITE: TEXT_WHITE_BUTTON_STYLES,
  },
  UNDERLINE: {
    BLACK: UNDERLINE_BLACK_BUTTON_STYLES,
    BLUE: UNDERLINE_BLUE_BUTTON_STYLES,
    WHITE: UNDERLINE_WHITE_BUTTON_STYLES,
  },
};

const BUTTON_SIZE_STYLES = {
  SQUARE: {
    LARGE: `px-6 py-4 tracked-medium`,
    SMALL: `px-6 py-3 tracked-medium lg:tracked-small`,
  },
  ROUND: {
    LARGE: `px-6 py-4 tracked-medium`,
    SMALL: `px-6 py-3 tracked-medium lg:tracked-small`,
  },
  OUTLINE: {
    LARGE: `h-12 ${LARGE_TEXT_STYLES}`,
    SMALL: `h-10 ${LARGE_TEXT_STYLES}`,
  },
  TEXT: {
    LARGE: LARGE_TEXT_STYLES,
    SMALL: SMALL_TEXT_STYLES,
  },
  UNDERLINE: {
    LARGE: 'tracked-medium',
    SMALL: 'tracked-small',
  },
};

const SlatButton: FC<any> = ({
  className,
  type = SQUARE_BUTTON_TYPE,
  color = BLACK_BUTTON_COLOR,
  size = LARGE_SIZE,
  as = 'button',
  ...props
}) => {
  let ContainerType;
  switch (as) {
    case 'a':
    case 'link':
    case 'AppLink':
      ContainerType = AppLink;
      break;
    case 'AuthenticatedAppLink':
      ContainerType = AuthenticatedAppLink;
      break;
    case 'button':
      ContainerType = `button`;
      break;
    // Can this allow creating div buttons as well?
    default:
      ContainerType = `${as}`;
      break;
  }

  return (
    <ContainerType
      className={cn(
        // @ts-expect-error
        BUTTON_TYPE_STYLES[type],
        // @ts-expect-error
        BUTTON_SIZE_STYLES[type][size],
        // @ts-expect-error
        BUTTON_COLOR_STYLES[type][color],
        'cursor-pointer',
        className
      )}
      {...props}
    />
  );
};

export default SlatButton;
